module.exports = __webpack_public_path__ + "img/chevron-right-icon.7d1b8f78.svg";